/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type PopularSearchesSitemapLayout_viewer = {
    readonly popularSearchesSitemap: {
        readonly categoryName: string | null;
        readonly breadcrumbs: ReadonlyArray<{
            readonly displayName: string | null;
            readonly path: string | null;
        }> | null;
        readonly mostPopularBuyPages: {
            readonly " $fragmentRefs": FragmentRefs<"PopularSearchesSitemapLinksBlock_connectionLinks">;
        } | null;
        readonly descendantCategories: ReadonlyArray<{
            readonly " $fragmentRefs": FragmentRefs<"PopularSearchesSitemapLinksBlock_links">;
        }> | null;
        readonly otherPopularBuyPages: {
            readonly numberOfPages: number | null;
            readonly " $fragmentRefs": FragmentRefs<"PopularSearchesSitemapLinksBlock_connectionLinks">;
        } | null;
    } | null;
    readonly " $refType": "PopularSearchesSitemapLayout_viewer";
};
export type PopularSearchesSitemapLayout_viewer$data = PopularSearchesSitemapLayout_viewer;
export type PopularSearchesSitemapLayout_viewer$key = {
    readonly " $data"?: PopularSearchesSitemapLayout_viewer$data;
    readonly " $fragmentRefs": FragmentRefs<"PopularSearchesSitemapLayout_viewer">;
};



const node: ReaderFragment = (function(){
var v0 = {
  "args": null,
  "kind": "FragmentSpread",
  "name": "PopularSearchesSitemapLinksBlock_connectionLinks"
};
return {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "page"
    },
    {
      "kind": "RootArgument",
      "name": "uriRef"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "PopularSearchesSitemapLayout_viewer",
  "selections": [
    {
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "uriRef",
          "variableName": "uriRef"
        }
      ],
      "concreteType": "PopularSearchesSitemapType",
      "kind": "LinkedField",
      "name": "popularSearchesSitemap",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "categoryName",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "LinkData",
          "kind": "LinkedField",
          "name": "breadcrumbs",
          "plural": true,
          "selections": [
            {
              "alias": "displayName",
              "args": null,
              "kind": "ScalarField",
              "name": "text",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "path",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": "mostPopularBuyPages",
          "args": [
            {
              "kind": "Literal",
              "name": "first",
              "value": 40
            }
          ],
          "concreteType": "PopularBuyPagesConnection",
          "kind": "LinkedField",
          "name": "popularBuyPages",
          "plural": false,
          "selections": [
            (v0/*: any*/)
          ],
          "storageKey": "popularBuyPages(first:40)"
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "LinkData",
          "kind": "LinkedField",
          "name": "descendantCategories",
          "plural": true,
          "selections": [
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "PopularSearchesSitemapLinksBlock_links"
            }
          ],
          "storageKey": null
        },
        {
          "alias": "otherPopularBuyPages",
          "args": [
            {
              "kind": "Literal",
              "name": "first",
              "value": 200
            },
            {
              "kind": "Variable",
              "name": "page",
              "variableName": "page"
            },
            {
              "kind": "Literal",
              "name": "pageStartOffset",
              "value": 40
            }
          ],
          "concreteType": "PopularBuyPagesConnection",
          "kind": "LinkedField",
          "name": "popularBuyPages",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "numberOfPages",
              "storageKey": null
            },
            (v0/*: any*/)
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};
})();
(node as any).hash = '3d7f30e3e0ae23fd212d6a10791c3cac';
export default node;
